import type { IExportAccessRepository } from '../repositories/IExportAccessRepository.js';

interface Deps { exportAccessRepository: IExportAccessRepository; }
export interface CreateExportGrantInput { orgId: string; exportKey: string; }
export function createCreateExportGrantUseCase({ exportAccessRepository }: Deps) {
  return async function createExportGrant(input: CreateExportGrantInput): Promise<void> {
    return exportAccessRepository.createGrant(input);
  };
}
